{
  "page": {
    "intro": "How the shop's tax works: the 10% inside every price, the 登録番号 on receipts, overseas orders and tax-free sales. The example on the right shows the result right away.",
    "load_failed": "The tax settings could not be loaded."
  },
  "tabs": {
    "label": "Tax screens",
    "settings": "Settings",
    "calendar": "Law dates",
    "tax_free": "Tax-free sales (免税)",
    "report": "Month report",
    "documents": "Find documents"
  },
  "jct": {
    "title": "Consumption tax (消費税)",
    "intro": "Prices in the shop always include the 10% tax (税込). The tax is worked out once per receipt.",
    "rate": "Tax rate",
    "rate_value": "{{rate}}% — included in every price",
    "rate_help": "Japanese law asks shops to show prices with the tax included (総額表示). The rate is fixed and cannot be changed here.",
    "rate_note": "Set by law — the same for every card and box.",
    "rounding": "Rounding",
    "rounding_per_document_floor": "Once per receipt, rounded down",
    "rounding_per_document_round_half_up": "Once per receipt, rounded to the nearest yen",
    "rounding_per_document_ceil": "Once per receipt, rounded up",
    "rounding_help": "The インボイス rules allow rounding only once per receipt and per rate. The shop rounds down.",
    "rounding_note": "Receipts already given keep the way they were rounded.",
    "registration": "Registration number (登録番号)",
    "registration_help": "The number of the shop as a qualified invoice issuer: the letter T and 13 digits. It is printed on every receipt.",
    "registration_hint": "Check it on the 国税庁 公表サイト before saving.",
    "registration_placeholder": "This is a sample number — enter the shop's real 登録番号.",
    "registration_format": "The 登録番号 must be T followed by 13 digits.",
    "business_name_ja": "Business name (Japanese)",
    "business_name_en": "Business name (English)",
    "business_name_help": "The name that is registered with the 登録番号. It is printed on receipts.",
    "tax_office": "Tax office (税務署)",
    "tax_office_help": "The tax office the shop reports to.",
    "fiscal_year": "Tax year starts in",
    "fiscal_year_help": "The first month of the shop's tax year.",
    "month": "Month {{month}}",
    "business_type": "The shop is run by",
    "business_type_help": "A company or a person (個人事業者). Some special rules are only for people.",
    "business_corporation": "A company (法人)",
    "business_individual": "A person (個人事業者)",
    "method": "How the tax on sales is added up",
    "method_help": "割戻し adds up all sales first; 積上げ adds up the tax printed on each receipt. Choose with your accountant.",
    "method_warimodoshi": "割戻し計算",
    "method_warimodoshi_desc": "The tax is worked out from the month's total sales.",
    "method_tsumiage": "積上げ計算",
    "method_tsumiage_desc": "The tax of each receipt is added up.",
    "ask_accountant": "Ask your 税理士",
    "simplified": "Simplified tax (簡易課税)",
    "simplified_desc": "Only when the tax office accepted it for a period.",
    "simplified_help": "A simpler way to work out the tax for small businesses. It needs a start and an end date.",
    "simplified_from": "Simplified tax from",
    "simplified_to": "Simplified tax until",
    "small_business": "Special rule for small businesses",
    "small_business_help": "2割特例 and 3割特例 lower the tax to pay for a few years. The law dates decide when they end.",
    "small_none": "None",
    "small_2wari": "2割特例",
    "small_2wari_ended": "This rule has ended.",
    "small_3wari": "3割特例",
    "small_3wari_desc": "Only for a person running the shop, in the tax years the law allows.",
    "small_3wari_not_now": "Not available on this date.",
    "small_until": "Until {{date}}",
    "credit": "Buy-ins from people without a 登録番号",
    "credit_help": "When the shop buys cards from a person without a 登録番号, only part of the tax can be deducted. The law lowers it step by step.",
    "credit_value": "{{rate}}% of the tax can be deducted (up to {{cap}} per person per year)",
    "credit_next": "Changes to {{rate}}% on"
  },
  "export": {
    "title": "Overseas orders",
    "intro": "Cards sent abroad are sold without the 10% tax (輸出免税), as long as the shop keeps the proof.",
    "policy": "Price for overseas customers",
    "policy_help": "Take the tax out of the normal price, or use a separate price for each market.",
    "strip_tax": "Take the tax out (税抜で販売)",
    "strip_tax_example": "A card at {{price}} is sold abroad for {{base}}.",
    "market_price": "Separate overseas price",
    "market_price_desc": "Each market has its own price (set in Markets).",
    "evidence_required": "Keep the export proof for every overseas order",
    "evidence_required_desc": "The order page asks for the shipping proof until it is kept.",
    "evidence_help": "Without the proof, the sale counts as a sale in Japan with 10% tax.",
    "postal_limit": "Post limit without an export permit",
    "postal_limit_help": "Up to this value per parcel, the post office receipt and slip copy are enough. Above it, an export permit (輸出許可書) is needed.",
    "postal_limit_hint": "The law sets ¥200,000 today.",
    "block_cash": "No cash for overseas orders",
    "block_cash_desc": "Cash payments cannot prove who paid, so they are refused for tax-free export."
  },
  "taxfree": {
    "title": "Tax-free sales for visitors (免税)",
    "intro": "Only at the shop counter, with the 輸出物品販売場 licence.",
    "licensed": "The shop has the 輸出物品販売場 licence",
    "licensed_desc": "Switches tax-free sales on at the counter.",
    "licensed_help": "The licence from the tax office that allows tax-free sales to visitors.",
    "license_granted_on": "Date on the licence (許可年月日)",
    "license_granted_on_help": "The date written on the licence from the tax office. It tells the system whether the licence is from before or after the new rules.",
    "filing": "Electronic filing done on (電子化届出)",
    "filing_help": "Shops with a licence must file the electronic notice or the licence ends.",
    "filing_deadline": "Still to do — {{days}} days left, deadline",
    "regime_now": "How tax-free works today",
    "regime": {
      "exemption": "免税価格方式 — the visitor pays without the tax",
      "refund": "リファンド方式 — the visitor pays the full price and gets the tax back after customs"
    },
    "regime_switch": "Changes to リファンド方式 in {{days}} days, on",
    "regime_unknown": "Could not read the law dates right now.",
    "regime_overridden": "The shop set this by hand — it does not follow the law dates.",
    "regime_refund_explain": "With リファンド方式 the shop pays the tax back itself once customs confirm the visitor took the goods out (within 90 days).",
    "override": "Follow the law dates",
    "override_help": "Leave on \"Automatic\". Choose by hand only when the tax office told you to.",
    "override_auto": "Automatic",
    "override_auto_desc": "Changes by itself on the law date.",
    "override_warning": "There is no period where both ways are used at once. Use this only when the tax office told you.",
    "exemption_ended": "The old way (tax taken off at the till) has ended. Only the refund way is used now — choose “Automatic” and save.",
    "min_amount": "Smallest tax-free purchase",
    "min_amount_help": "Below this amount (without tax) a purchase cannot be tax-free.",
    "high_value": "Serial number needed from",
    "high_value_help": "For goods at or above this price the serial or certificate number must be kept.",
    "sender_id": "Sender ID (送信者識別符号)",
    "sender_id_help": "Given by the tax office for sending 購入記録情報.",
    "store_id": "Store ID (販売場識別符号)",
    "store_id_help": "The ID of this shop as a tax-free store.",
    "cert": "Sending certificate reference",
    "cert_replace": "New certificate reference",
    "cert_help": "Where the certificate for sending is kept. Only the last 4 characters are shown.",
    "cert_hint": "Leave empty to keep the one saved.",
    "refund_provider": "Who pays the tax back",
    "refund_provider_help": "The shop itself, or a refund company.",
    "provider_self": "The shop",
    "provider_self_desc": "Staff send the money after customs confirm.",
    "provider_agent": "A refund company",
    "provider_agent_desc": "A company pays the visitor for the shop.",
    "agent_name": "Name of the refund company",
    "self_refund_warning": "Paying money back to people abroad may need a licence (資金移動業). Ask your 税理士 or 行政書士 first.",
    "refund_method": "Usual way to pay back",
    "refund_method_help": "Chosen for each refund; this is the first choice.",
    "files_now": "Until the tax office connection is ready, the 購入記録情報 files are made on the tax-free page.",
    "records_link": "Open tax-free sales"
  },
  "refund_method": {
    "bank_transfer": "Bank transfer",
    "cash_agent": "Cash through an agent",
    "agent_company": "Refund company",
    "stripe_refund": "Card refund",
    "stripe_later": "Coming with the card connection"
  },
  "advanced": {
    "title": "For the accountant",
    "intro": "Choices the owner sets once with the 税理士.",
    "journal": "Booking of tax-free sales",
    "journal_help": "When a sale moves from taxed to tax-free in the books.",
    "journal_per_record": "For each sale",
    "journal_monthly": "Once a month",
    "consigned": "Cards sold for people (consignment)",
    "consigned_help": "How cards that belong to a person are counted for tax.",
    "consigned_out_of_scope": "Only the shop's fee is taxed",
    "consigned_out_of_scope_desc": "The receipt shows 委託品／インボイス対象外.",
    "consigned_gross": "The whole price is taxed",
    "consigned_gross_desc": "Use only if your accountant says so.",
    "commission_tax": "The shop's fee includes tax",
    "commission_tax_desc": "The consignment fee is a 税込 amount."
  },
  "preview": {
    "title": "Example",
    "updating": "Updating the example",
    "loading": "Loading the example…",
    "owner_only": "Only the owner can see the live example.",
    "domestic": "Sold in Japan",
    "export": "Sent abroad",
    "taxfree": "Tax-free at the counter",
    "price": "Price",
    "base": "Without tax",
    "tax": "Tax {{rate}}%",
    "tax_zero": "Tax 0%",
    "customer_pays": "Customer pays",
    "export_market": "The price set for the customer's market is used.",
    "refund_after_customs": "Paid back after customs",
    "taxfree_exemption_note": "The visitor pays the price without tax at the counter.",
    "taxfree_refund_note": "The shop pays the tax back once customs confirm (within 90 days).",
    "rounding_per_document_floor": "Tax worked out once per receipt, rounded down.",
    "rounding_per_document_round_half_up": "Tax worked out once per receipt, rounded to the nearest yen.",
    "rounding_per_document_ceil": "Tax worked out once per receipt, rounded up."
  },
  "save": {
    "button": "Save",
    "changes_one": "{{count}} change",
    "changes_other": "{{count}} changes",
    "no_changes": "No changes",
    "effective_from": "Use from",
    "effective_from_hint": "Empty = from tomorrow. Today only if no receipt was given today.",
    "confirm_title": "Save the tax settings?",
    "confirm_from": "Every receipt from {{date}} follows the new settings.",
    "confirm_tomorrow": "Every receipt from tomorrow follows the new settings.",
    "confirm": "Save",
    "saved": "Saved — used from {{date}}.",
    "replaced": "Saved — it replaces the change planned for {{date}}.",
    "scheduled": "You are looking at the change planned (version {{version}}). It is used from",
    "read_only": "You can read these settings. Only the owner can change them."
  },
  "fields": {
    "invoiceRegistrationNumber": "Registration number (登録番号)",
    "businessNameJa": "Business name (Japanese)",
    "businessNameEn": "Business name (English)",
    "storeNameEn": "Shop name (English)",
    "taxOffice": "Tax office",
    "businessType": "The shop is run by",
    "fiscalYearStartMonth": "Tax year start",
    "salesTaxMethod": "How the tax on sales is added up",
    "simplifiedTaxationFlag": "Simplified tax",
    "simplifiedTaxationFrom": "Simplified tax from",
    "simplifiedTaxationTo": "Simplified tax until",
    "smallBusinessSpecial": "Special rule for small businesses",
    "exportPricingPolicy": "Price for overseas customers",
    "exportEvidenceRequired": "Keep the export proof",
    "exportBlockCash": "No cash for overseas orders",
    "postalExportLimit": "Post limit without an export permit",
    "taxFreeLicensed": "Tax-free licence",
    "electronicFilingDoneAt": "Electronic filing",
    "taxFreeRegimeOverride": "How tax-free works (by hand)",
    "clearTaxFreeRegimeOverride": "How tax-free works (automatic)",
    "taxFreeMinAmount": "Smallest tax-free purchase",
    "taxFreeHighValueThreshold": "Serial number needed from",
    "ntaSenderId": "Sender ID",
    "ntaStoreId": "Store ID",
    "ntaClientCertRef": "Sending certificate",
    "refundProvider": "Who pays the tax back",
    "refundAgentName": "Refund company",
    "defaultRefundMethod": "Usual way to pay back",
    "journalMode": "Booking of tax-free sales",
    "consignedIndividualTreatment": "Cards sold for people",
    "commissionIncludesTax": "Fee includes tax"
  },
  "issues": {
    "invalid_registration_number": "The 登録番号 must be T followed by 13 digits.",
    "registration_number_placeholder": "This is the sample number — enter the shop's real 登録番号.",
    "registration_number_unverified": "Check this number on the 国税庁 公表サイト before customers see it.",
    "taxfree_ids_missing": "A tax-free shop needs the sender ID and the store ID (or a refund company).",
    "electronic_filing_pending": "The electronic filing (電子化届出) is still to do — the licence ends without it.",
    "simplified_taxation_dates_required": "Simplified tax needs a start and an end date.",
    "wari2_ended": "The 2割特例 has ended for this date.",
    "wari3_not_allowed": "The 3割特例 is only for a person running the shop in the years the law allows.",
    "feature_disabled": "Card refunds come with the card connection — choose another way.",
    "rounding_change_consistency": "Receipts already given keep the old rounding.",
    "rounding_change_period_boundary": "A new rounding can only start with the next tax year.",
    "field_locked": "This is set by law and cannot be changed.",
    "settings_not_configured": "No tax settings saved yet — the standard values are shown.",
    "taxfree_license_date_missing": "Enter the date on the licence: a licence from before the new rules ends unless the electronic filing (電子化届出) was done in time.",
    "taxfree_license_lapsed": "This licence ended: it is from before the new rules and no electronic filing (電子化届出) was recorded by the deadline. Enter the filing date if it was done, or switch tax-free sales off.",
    "taxfree_refund_completion_missing": "The system cannot pay the tax back to visitors yet. Do not sell tax-free until this is ready, or use a refund company.",
    "taxfree_refund_override_early": "The refund method starts on the date in the legal calendar. Using it earlier is not confirmed — ask the tax accountant first.",
    "other": "Please check this value."
  },
  "calendar": {
    "title": "Law dates",
    "load_failed": "The law dates could not be loaded.",
    "rules_today": "Rules that apply today",
    "today": "Today",
    "days_left_one": "In {{count}} day",
    "days_left_other": "In {{count}} days",
    "days_ago_one": "{{count}} day ago",
    "days_ago_other": "{{count}} days ago",
    "unverified": "Not confirmed yet",
    "todo": "What to do",
    "source": "Source",
    "accessed": "checked {{date}}",
    "mark_done": "Mark as done",
    "done_on": "Done on {{date}}",
    "saved": "Saved.",
    "code": {
      "credit_80_ends": "Last day of the 80% deduction",
      "wari2_ends": "2割特例 ends",
      "credit_70_starts": "Deduction becomes 70%",
      "taxfree_new_license_open": "New tax-free licences can be asked for",
      "taxfree_exemption_ends": "Last day of 免税価格方式 (electronic filing deadline)",
      "taxfree_refund_starts": "リファンド方式 starts",
      "credit_50_starts": "Deduction becomes 50%",
      "shogaku_tokurei_ends": "少額特例 ends",
      "credit_30_starts": "Deduction becomes 30%",
      "credit_0_starts": "Deduction ends"
    },
    "effect": {
      "credit": "Buy-ins from people without a 登録番号: {{rate}}% of the tax can be deducted.",
      "wari2_ends": "The 2割特例 can no longer be used.",
      "taxfree_new_license_open": "Shops can ask the tax office for a new tax-free licence.",
      "taxfree_exemption_ends": "Last day visitors pay without tax at the counter. The electronic filing must be done by now.",
      "taxfree_refund_starts": "Visitors pay the full price; the shop pays the tax back after customs ({{days}} days).",
      "shogaku_tokurei_ends": "Small purchases under ¥10,000 need an invoice again.",
      "other": "A tax rule changes on this day."
    }
  },
  "alert_action": {
    "review_buylist_credit": "Check the buy-in prices with your accountant.",
    "review_small_business_special": "Check the special rule with your accountant.",
    "decide_taxfree_licence": "Decide whether to ask for the tax-free licence.",
    "file_electronic_notification": "File the 電子化届出 with the tax office.",
    "brief_pos_staff_refund_regime": "Explain the new tax-free steps to the counter staff.",
    "decide_refund_method": "Decide how the shop pays the tax back.",
    "retry_taxfree_refund": "Try the refund again.",
    "other": "Check this with your accountant."
  },
  "rules": {
    "taxfree_regime": {
      "exemption": "Tax-free: 免税価格方式 (the visitor pays without tax).",
      "refund": "Tax-free: リファンド方式 (full price, tax paid back after customs)."
    },
    "nonregistered_credit_rate": "Buy-ins from people without a 登録番号: {{rate}}% deductible, up to {{cap}} per person per year.",
    "wari2": {
      "available": "The 2割特例 can be used.",
      "ended": "The 2割特例 has ended."
    },
    "shogaku_tokurei": {
      "available": "Small purchases under ¥10,000 need no invoice (少額特例).",
      "ended": "The 少額特例 has ended."
    },
    "wari3": {
      "available_for_individual": "The 3割特例 can be used by a person running the shop."
    },
    "taxfree_new_license_open": "New tax-free licences can be asked for.",
    "regime_overridden": "Set by hand to {{override}} (the law dates say {{calendar}}).",
    "other": "A tax rule applies."
  },
  "records": {
    "title": "Tax-free sales (免税)",
    "intro": "Every tax-free sale: sending to the tax office, the customs check within 90 days and the tax paid back.",
    "views": "Which sales",
    "view": {
      "pending": "Waiting for customs",
      "due": "To pay back",
      "deadline_soon": "7 days or less left",
      "send_failed": "Not sent",
      "failed": "Pay-back failed",
      "refunded": "Paid back",
      "expired": "Time ran out",
      "all": "All"
    },
    "view_help": {
      "pending": "Customs has not confirmed yet. Soonest deadline first.",
      "due": "Customs confirmed more than 3 days ago — pay the tax back now.",
      "deadline_soon": "The 90 days end within a week.",
      "send_failed": "The 購入記録情報 did not reach the tax office, or was sent late.",
      "failed": "The money could not be paid back — try again or choose another way.",
      "refunded": "The tax was paid back.",
      "expired": "No customs result in time — the sale stays taxed.",
      "all": "Every tax-free sale, newest first."
    },
    "order": "Order",
    "purchased": "Bought on",
    "buyer": "Buyer",
    "base": "Without tax",
    "tax": "Tax",
    "regime": "Way",
    "sent": "Sent to tax office",
    "late": "Sent late (事後送信)",
    "customs": "Customs",
    "deadline": "Deadline",
    "status": "State",
    "days_left_one": "{{count}} day left",
    "days_left_other": "{{count}} days left",
    "deadline_today": "Ends today",
    "deadline_passed": "Time ran out",
    "search": "Search",
    "search_placeholder": "Order or tracking number",
    "empty": "No tax-free sales here."
  },
  "ui_status": {
    "refund_pending": "Waiting",
    "refunded": "Paid back",
    "taxable_final": "Stays taxed",
    "exempted": "Tax-free",
    "cancelled": "Cancelled",
    "failed": "Pay-back failed",
    "written_off": "Closed (雑益)"
  },
  "transmission": {
    "pending": "Waiting to send",
    "exported": "In a file",
    "sent": "Sent",
    "accepted": "Received",
    "rejected": "Refused",
    "cancelled": "Cancelled"
  },
  "transmission_kind": {
    "send": "Send",
    "cancel": "Cancel",
    "resend": "Send again"
  },
  "customs": {
    "not_applicable": "Not needed",
    "pending": "Waiting",
    "confirmed": "Confirmed (税関確認済)",
    "denied": "Not confirmed",
    "expired": "Time ran out"
  },
  "customs_source": {
    "manual": "typed by staff",
    "csv": "from a file",
    "nta_api": "from the tax office"
  },
  "buyer_type": {
    "short_stay": "Short stay",
    "landing_permit": "Landing permit",
    "jp_nonresident": "Japanese living abroad"
  },
  "goods": {
    "general": "General goods",
    "consumable": "Consumables"
  },
  "refund_request": {
    "requested": "Sending",
    "refunded": "Paid",
    "failed": "Failed",
    "superseded": "Replaced"
  },
  "drawer": {
    "title": "Tax-free sale {{number}}",
    "loading": "Loading…",
    "purchased": "Bought on",
    "open_order": "Open the order",
    "refund_ready": "Customs confirmed — the tax can be paid back now.",
    "refund_wait_customs": "Pay back only after customs confirm.",
    "refund_closed_expired": "No customs result in time — nothing is paid back.",
    "refund_done": "The tax has been paid back.",
    "exemption_note": "免税価格方式: the visitor paid without tax; only the sending is followed here.",
    "buyer": "Buyer",
    "passport": "Passport",
    "passport_hidden": "The passport number is only shown to staff allowed to check IDs.",
    "passport_show": "Show for 30 seconds",
    "passport_hides": "hides in {{seconds}} s",
    "items": "Goods",
    "item": "Item",
    "qty": "Qty",
    "serial": "Serial",
    "total": "Total",
    "sending": "Sending to the tax office",
    "transmission_no": "No. {{no}}",
    "customs": "Customs",
    "checked_at": "Checked",
    "manual_until_api": "Typed by staff until the tax office connection is ready.",
    "refund_title": "Paying the tax back",
    "refund_amount": "Tax to pay back:",
    "refunded_at": "Paid back on",
    "refund_sending": "The pay-back is on its way (the usual way from the tax settings) — the transfer steps are on the order.",
    "retransmit": "Send again",
    "resend": "Correct after a return (洗替)",
    "confirmed": "Customs confirmed",
    "denied": "Not tax-free",
    "write_off": "Close without paying",
    "refund": "Record the pay-back",
    "done": {
      "confirmed": "Customs confirmed — the pay-back has started.",
      "denied": "Saved — the sale stays taxed.",
      "retransmit": "Queued to send again.",
      "resend": "The correction is being sent.",
      "write_off": "Closed.",
      "refund": "The pay-back was sent."
    },
    "refund_change": "Change how it is paid back",
    "wait_sending": "The 購入記録情報 has not been sent yet — send it first; customs is recorded after that."
  },
  "customs_dialog": {
    "confirmed_title": "Customs confirmed?",
    "confirmed_desc": "Customs confirmed the visitor took the goods out of Japan.",
    "denied_title": "Not tax-free?",
    "denied_desc": "Customs did not confirm — the sale stays taxed.",
    "checked_at": "Checked on",
    "ref": "Reference (optional)",
    "reason": "Why",
    "checked_at_invalid": "The check date cannot be before the purchase or after the deadline."
  },
  "resend": {
    "title": "Correct after a return (洗替)",
    "desc": "The sent 購入記録情報 is cancelled and the remaining goods are sent again.",
    "keep": "Goods the visitor kept",
    "partial": "The ticked goods are sent again.",
    "full": "Nothing ticked — the whole sale is cancelled.",
    "reason": "Why (optional)",
    "submit": "Send the correction"
  },
  "write_off": {
    "title": "Close without paying back?",
    "consequence": "The tax stays with the shop and is booked as 雑益. Use this only when the visitor cannot be reached."
  },
  "refund_dialog": {
    "title": "Record the pay-back",
    "desc": "Choose how the visitor gets the tax back.",
    "amount": "Tax to pay back:",
    "method": "How",
    "bank_desc": "The shop sends the money to the visitor's bank.",
    "cash_agent_desc": "An agent hands the cash to the visitor.",
    "agent_desc": "A refund company pays the visitor.",
    "bank_on_file": "The visitor's bank details are saved.",
    "bank_name": "Bank",
    "branch_name": "Branch",
    "account_type": "Account type",
    "futsu": "Ordinary (普通)",
    "toza": "Current (当座)",
    "account_number": "Account number / IBAN",
    "account_name": "Account holder",
    "swift": "SWIFT code",
    "bank_missing": "Enter the visitor's bank details first.",
    "bank_needs_kyc": "Only staff allowed to check IDs can enter bank details.",
    "next": "Next",
    "confirm_title": "Pay the tax back?",
    "confirm": "The tax goes back to the visitor by {{method}}. This is saved in the history.",
    "confirm_button": "Pay back"
  },
  "export_files": {
    "open": "Files for the tax office",
    "title": "購入記録情報 files",
    "desc": "Until the tax office connection is ready, the sales of a period are put into files to upload.",
    "from": "From",
    "to": "To",
    "version": "File layout",
    "version_help": "Sales made under リファンド方式 use the new layout; earlier sales use the old one.",
    "version_v2": "Before リファンド方式",
    "version_v3": "リファンド方式",
    "make": "Make the files",
    "made": "Files made: {{count}} sales.",
    "made_list": "Files made",
    "none": "No files yet.",
    "count_one": "{{count}} sale",
    "count_other": "{{count}} sales",
    "status_exported": "Not handed in",
    "status_submitted": "Handed in",
    "file_csv": "Spreadsheet file",
    "file_json": "Data file",
    "file_manifest": "File list with checks",
    "reference": "Receipt number of the tax office",
    "mark": "Mark as handed in",
    "marked": "Saved as handed in.",
    "submitted_on": "Handed in on"
  },
  "customs_import": {
    "open": "Customs results from a file",
    "title": "Customs results from a file",
    "desc": "The file is checked first — nothing changes until you apply it.",
    "columns": "Columns: tracking or sending number, result (confirmed / denied), checked date, reference.",
    "choose": "Choose the file",
    "checking": "Checking the file…",
    "summary": "{{ok}} of {{total}} lines can be applied.",
    "line": "Line",
    "record": "Sale",
    "result": "Result",
    "outcome": "Check",
    "apply_one": "Apply {{count}} line",
    "apply_other": "Apply {{count}} lines",
    "applied_one": "{{count}} sale updated.",
    "applied_other": "{{count}} sales updated.",
    "outcomes": {
      "ok": "OK",
      "not_found": "Sale not found",
      "already_final": "Already decided",
      "not_applicable": "Not a リファンド方式 sale",
      "not_transmitted": "Not sent yet",
      "duplicate": "Twice in the file",
      "invalid": "Unreadable line",
      "after_deadline": "After the deadline"
    }
  },
  "report": {
    "title": "Tax-free month report",
    "intro": "The tax-free sales of one month in Japan time — for the books and the accountant.",
    "month": "Month",
    "previous": "Previous month",
    "next": "Next month",
    "of_month": "Month {{month}}",
    "csv": "Download (CSV)",
    "pdf": "Download (PDF)",
    "pdf_busy": "Making the PDF…",
    "pdf_after_month": "The PDF of a month can be made from the 1st of the next month (Japan time) — until then the numbers still change. Use the CSV or this screen meanwhile.",
    "pdf_ready": "PDF {{number}} saved",
    "pdf_ready_updated": "The figures changed, so a new version ({{version}}) of the PDF was made: {{number}}",
    "count_one": "{{count}} sale",
    "count_other": "{{count}} sales",
    "tax": "Tax",
    "incl": "With tax",
    "journal_moved": "Moved from taxed to tax-free (customs confirmed)",
    "refunded": "Paid back",
    "outstanding": "Still to pay back",
    "expired": "Stays taxed (time ran out)",
    "written_off": "Closed without paying (雑益)",
    "late": "Sent late",
    "by_status": "Sales by state",
    "unsubmitted": "Files not handed in yet",
    "open_files": "Open the files",
    "rows": "Sales",
    "disclaimer": "A helper for the books — the 税理士 confirms the figures for the tax report."
  },
  "evidence": {
    "title": "Export proof (輸出免税)",
    "page_title": "Export proof",
    "page_intro": "Keep these papers so the order stays tax-free. They are kept for 7 years.",
    "status": {
      "not_required": "Not needed",
      "missing": "Proof missing",
      "partial": "Some proof missing",
      "complete": "Proof kept"
    },
    "ship_to": "Ship to",
    "declared": "Declared value",
    "paid_by": "Paid by",
    "shipped": "Sent on",
    "payment_class": {
      "cash": "Cash",
      "traceable": "Card or transfer",
      "unknown": "Not known"
    },
    "not_required": {
      "settings_evidence_not_required": "The tax settings say no proof is kept.",
      "order_cancelled": "The order was cancelled.",
      "picked_up": "Picked up in the shop — this is a sale in Japan.",
      "other": "No export proof is needed for this order."
    },
    "warning": {
      "RECIPIENT_DAY_TOTAL_OVER_LIMIT": "The same receiver gets {{total}} today — an export permit (輸出許可書) is needed.",
      "domestic_address": "The address is in Japan (a forwarding company?) — this is not an export.",
      "other": "Check this order's proof."
    },
    "checklist": "Proof to keep",
    "kind": {
      "carrier_record": "Post office record (引受)",
      "shipping_slip_copy": "Copy of the shipping slip (伝票控え)",
      "export_permit": "Export permit (輸出許可書)",
      "import_permit_equivalent": "Proof of import in the country of arrival"
    },
    "kind_help": {
      "carrier_record": "Added by itself when the parcel is sent with tracking.",
      "shipping_slip_copy": "A photo of the customer's copy of the slip.",
      "export_permit": "Needed above the post limit or when a courier declares the parcel.",
      "import_permit_equivalent": "Needed when the payer cannot be proved (cash)."
    },
    "still_missing": "still missing",
    "kept": "kept",
    "file_kept": "File kept",
    "from_shipment": "from the shipment",
    "remove": "Remove",
    "remove_aria": "Remove the {{kind}}",
    "remove_title": "Remove this proof?",
    "remove_consequence": "The order may lose its tax-free proof. This is only possible within 24 hours.",
    "removed": "Removed.",
    "add_photo": "Photo or PDF of the {{kind}}",
    "type_number": "Type the number instead",
    "reference": "Number on the paper",
    "save_reference": "Save",
    "added": "Proof kept.",
    "now_complete": "All proof is kept — the order is complete.",
    "carrier_auto": "This comes by itself when the parcel is marked as sent with tracking.",
    "invoice_hint": "The commercial invoice is printed from the order's documents.",
    "open_order": "Open the order",
    "retention": "Kept 7 years in the shop's document store (電帳法)."
  },
  "queue": {
    "title": "Export proof to add",
    "intro": "Overseas orders whose proof is not complete — oldest parcel first. Red after 30 days.",
    "tab_open": "Proof missing",
    "tab_complete": "Complete",
    "order": "Order",
    "status": "Proof",
    "missing": "Still missing",
    "age_one": "{{count}} day ago",
    "age_other": "{{count}} days ago",
    "empty": "All export proof is kept.",
    "empty_complete": "No complete orders yet.",
    "drawer_title": "Proof of {{number}}"
  },
  "documents": {
    "title": "Find documents (電帳法)",
    "intro": "Every receipt, invoice and statement the shop made is kept here for 7 years. Search by date, amount and customer — together or one by one — and download the kept file.",
    "form_label": "Search documents",
    "date": "Date of the sale (取引年月日)",
    "date_from": "From date",
    "date_to": "To date",
    "amount": "Amount (取引金額)",
    "amount_min": "From",
    "amount_max": "To",
    "amount_hint": "Whole yen",
    "counterparty": "Customer or consignor (取引先)",
    "counterparty_placeholder": "Name — part of it is enough",
    "number": "Document number",
    "number_placeholder": "e.g. R-2026-000123",
    "search": "Search",
    "clear": "Clear",
    "problem": {
      "dates_reversed": "The first date is after the second date.",
      "amounts_reversed": "The first amount is bigger than the second amount."
    },
    "found_one": "{{count}} document",
    "found_other": "{{count}} documents",
    "total": "total",
    "conditions_one": "{{count}} condition",
    "conditions_other": "{{count}} conditions together",
    "none": "No documents match.",
    "none_hint": "Try a wider date range or fewer conditions.",
    "col": {
      "date": "Date",
      "kind": "Kind",
      "number": "Number",
      "counterparty": "Customer / consignor",
      "amount": "Amount",
      "file": "File"
    },
    "version": "version {{version}}",
    "replaced": "Replaced by a newer one",
    "hold": "Kept longer",
    "open_source": "Open the sale",
    "download": "Download {{number}} (PDF)",
    "not_ready": "Being made…",
    "pdf_saved": "{{number}} saved",
    "csv": "Download the list (CSV)",
    "more": "Show more",
    "kept": "These are the files the shop issued — they are never changed. A correction is a new version that points to the old one.",
    "types": {
      "ryoshusho": "領収書 (receipt)",
      "kani_invoice": "適格簡易請求書 (simple invoice)",
      "tekikaku_invoice": "適格請求書 (invoice with name)",
      "henkan_invoice": "返還インボイス (refund invoice)",
      "refund_note": "Refund note",
      "commercial_invoice": "Commercial invoice (export)",
      "customs_declaration": "Customs form (CN22/CN23)",
      "packing_slip": "納品書 (packing slip)",
      "tax_free_slip": "免税 record",
      "taxfree_explanation": "免税 explanation",
      "refund_evidence": "Tax-free refund proof",
      "kaitori_meisai": "買取明細書 (buying from a customer)",
      "itaku_keiyaku": "委託契約書 (consignment agreement)",
      "seisan_sho": "精算書 (consignor statement)",
      "z_report": "日計表 (end-of-day report)",
      "kobutsu_style15": "古物台帳 printout — received (様式第15号)",
      "kobutsu_style16": "古物台帳 printout — sold (様式第16号)",
      "taxfree_monthly_report": "免税 month report",
      "supplier_invoice": "仕入明細書 (purchase statement)",
      "layaway_deposit_receipt": "預り証 (deposit receipt)"
    }
  }
}
